import {gql} from '@apollo/client'

export const CREATE_UPLOAD_PRESIGNER = gql`
  mutation CreateUploadPresigner($input: UploadPresignerInput!) {
    createUploadPresigner(input: $input) {
      id
      filename
      presignedUrl
      partSize
    }
  }
`

export const PRESIGN_UPLOAD_PARTS = gql`
  mutation PresignUploadParts($id: ID!, $partNumbers: [Int!]!) {
    presignUploadParts(id: $id, partNumbers: $partNumbers) {
      partNumber
      presignedUrl
    }
  }
`

export const ABANDON_UPLOAD = gql`
  mutation AbandonUpload($id: ID!) {
    abandonUpload(id: $id)
  }
`

export const COMPLETE_UPLOAD = gql`
  mutation CompleteUpload($id: ID!) {
    completeUpload(id: $id)
  }
`

export const RENAME_UPLOAD = gql`
  mutation RenameUpload($input: RenameInput!) {
    renameUpload(input: $input)
  }
`
